import { api } from '../api';

export type ReporteAbmWebEstado = 'alta' | 'baja';

/** Una fila por persona del legajo: el titular y cada familiar. */
export interface ReporteAbmWebRow {
  /** `_id` del legajo. Junto con `asociadoId` es la `key` de fila: un legajo da
   *  una fila por persona, y `legajo` + `dni` no es único entre organizaciones
   *  (dos empresas pueden tener el legajo "1"). */
  legajoId: string;
  /** `_id` del asociado de esta fila (titular o familiar). */
  asociadoId: string;
  legajo: string;
  dni: string;
  nombre: string;
  parentesco: string;
  medicard: string;
  estadoPersona: string;
  estadoLegajo: string;
  planReal: string;
  motivo: string | null;
  vigenciaAlta: string | null;
  vigenciaBaja: string | null;
  bajaFutura: boolean;
}

export interface ReporteAbmWebParams {
  /** Sin especificar, trae Altas y Bajas juntas. */
  estado?: ReporteAbmWebEstado;
  fechaDesde?: string;
  fechaHasta?: string;
  empresaId?: string;
  numero?: string;
  dni?: string;
}

export interface ReporteAbmWebPagina {
  items: ReporteAbmWebRow[];
  /** Total del filtro completo, no de la página. */
  total: number;
  page: number;
  pageSize: number;
}

/** Filas por página. El server tiene su propio techo (200). */
export const REPORTE_ABM_WEB_PAGE_SIZE = 25;

/**
 * Reporte ABM Web Empresas: altas/bajas de personas filtradas por estado y
 * fecha. Paginado — para bajar el universo completo del filtro está el export
 * async (`ExportModal` con tipo `reporte-abm-web`, que arma `PantallaReporte`),
 * no esta llamada.
 */
export async function getReporteAbmWeb(
  params: ReporteAbmWebParams,
  page = 1,
  pageSize = REPORTE_ABM_WEB_PAGE_SIZE,
): Promise<ReporteAbmWebPagina> {
  const { data } = await api.get<ReporteAbmWebPagina>('/legajos/reporte-abm-web', {
    params: { ...params, page, pageSize },
    // Sin esto axios espera para siempre (su default es 0): si el reporte se
    // demora, el usuario se queda mirando el skeleton sin fin.
    timeout: 60_000,
  });
  return data;
}
